import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { msg } from '@philips-emr/tws-core/lib/services';

import { FragmentNames, RootAliases } from '../codegen';

@Controller({ fragment: FragmentNames.ROOT })
export default class RootController {

  @OnMount(RootAliases.LAYOUT_ROOT)
  onRootLayoutMount(): void {
    document.title = msg('hi.title');
  }

}
